// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_wOp","cls2":"ExportFormatModal-cls2_o0G ExportFormatModal-cls1_wOp"};